'use client'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import useLocalizedRouter from '@/app/hooks/useLocalizedRouter'
import { useTranslation } from '@/app/i18n/client'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import AdVertiseHeader from './(components)/AdVertiseHeader'

const WebsiteModel = ({ tab }: { tab: React.ReactNode }) => {
  const { t } = useTranslation()
  const pushWithLocale = useLocalizedRouter()
  const [currentTab, setCurrentTab] = useState<string>('ad_home_page')
  useEffect(() => {
    pushWithLocale(`/advertise_page/website_ad/${currentTab}`)
  }, [currentTab])

  const selectOptions = [
    { value: 'ad_home_page', label: t('Home Page') },
    { value: 'ad_news_details_page', label: t('News Detail') },
    {
      value: 'ad_search_page',
      label: `${t('Search Results')} / ${t('Retail Partners')}`,
    },
    {
      value: 'ad_sales_offer_buyers_alert',
      label: t('Sales Offer / Buyer Alerts / Events'),
    },
    {
      value: 'ad_news_listing',
      label: t('News Listing'),
    },
    {
      value: 'ad_sales_offer_buyers_alert_details',
      label: t('Sales Offer / Buyer Alerts Details'),
    },
    {
      value: 'ad_contact_us',
      label: t('Contact Us'),
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="mobile-width">
      <div className="flex gap-7 items-center">
        <div className="text-[16px] text-[#6f6f6f] ml-[30px]">{t('Page')}</div>
        <div className="my-[13px]">
          <Select
            value={currentTab}
            onValueChange={(value) => {
              setCurrentTab(value)
            }}
          >
            <SelectTrigger className="w-[180px] selectTrigger">
              <SelectValue placeholder="" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {selectOptions.map((option) => (
                  <CustomErrorBoundary key={option.label}>
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  </CustomErrorBoundary>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="pb-[1px]">
        <div className="mobile:hidden block">
          <div className="bg-[#f0f0f0]">
            <main className="flex items-center pt-[26px] pb-[20px] px-[60px]">
              <Image
                loading="lazy"
                width={115.8}
                height={46.4}
                className="mr-[45.5px]"
                src="/assets/Icons/fructidor logo.svg"
                alt=""
              />
              <Image
                loading="lazy"
                width={23.7}
                height={23.7}
                className="mr-[46px]"
                src="/assets/Icons/barIcon.svg"
                alt=""
              />
              <div className="w-[705px] h-[36px] bg-[#fff] rounded-[18px] mr-[12.3px] flex items-center">
                <div className="ml-auto m-[3px] w-fit bg-[#e0e0e0] px-[18px] py-[5px] rounded-[18px] text-[12px] flex items-center">
                  {t('Search')}
                </div>
              </div>
              <Image
                loading="lazy"
                width={13.1}
                height={8.3}
                className="w-[20.1px] h-[18.3px] mr-[4px] grayscale "
                src="/assets/Icons/flags/americanFlag.png"
                alt=""
              />
              <p className="mr-[4px]">{t('English')}</p>
              <Image
                loading="lazy"
                width={7.6}
                height={4.3}
                className="mr-[10px] mobile:invisible"
                src="/assets/Icons/DownArrow.svg"
                alt=""
              />
              <div className="px-8 mr-[10px] py-2 border border-solid border-[#707070] rounded-[30px] bg-[#fff]">
                {t('Login')}
              </div>
            </main>
            <AdVertiseHeader />
          </div>
        </div>

        <div className="pt-[20px] mb-[50px] bg-[#fcfcfc]">{tab}</div>
      </div>
    </div>
  )
}

export default WebsiteModel
